<template>
  <div class="r1">
    <div v-html="html"></div>
  </div>
</template>
<script>
import http from "@/utils/axios";

export default {
  data() {
    return {
      html:""
    };
  },
  created() {
    this.$loading.hide();
    this.html = localStorage.getItem('coupon-uersbrandCouponRule');
    let { code } = this.$route.query
    if(!this.html){
      http({
        url: "order/coupon/queryCouponByCode/" + code,
        method: "get",
        parmes: {},
      }).then(rps=>{

      })
    }
  },
};
</script>
<style lang="less" scoped>
.r1{
  padding: 46px 50px 0 50px;
  font-size: 24px;
}
</style>
